import { render, staticRenderFns } from "./diseaseSearch.vue?vue&type=template&id=2988d4e1&scoped=true"
import script from "./diseaseSearch.vue?vue&type=script&lang=js"
export * from "./diseaseSearch.vue?vue&type=script&lang=js"
import style0 from "./diseaseSearch.vue?vue&type=style&index=0&id=2988d4e1&prod&scoped=true&lang=css"
import style1 from "./diseaseSearch.vue?vue&type=style&index=1&id=2988d4e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988d4e1",
  null
  
)

export default component.exports